import * as Schema from "effect/Schema";

export const ClaudeAccountIdentity = Schema.Struct({
  accountUuid: Schema.String,
  organizationUuid: Schema.String,
  email: Schema.String,
});
export type ClaudeAccountIdentity = typeof ClaudeAccountIdentity.Type;

export const ClaudeNativeAccountBinding = Schema.Struct({
  connectionId: Schema.String,
  previousConnectionIds: Schema.optionalKey(Schema.Array(Schema.String)),
  identity: ClaudeAccountIdentity,
  observedAt: Schema.String,
});
export type ClaudeNativeAccountBinding = typeof ClaudeNativeAccountBinding.Type;

export const ClaudeAccountOperation = Schema.Struct({
  mode: Schema.Literals(["verify", "reconnect"]),
  binding: ClaudeNativeAccountBinding,
});
export type ClaudeAccountOperation = typeof ClaudeAccountOperation.Type;

export const ClaudeCredentialOutcome = Schema.Literals([
  "verified",
  "rejected",
  "rate-limited",
  "unavailable",
  "identity-mismatch",
  "unverified",
]);
export type ClaudeCredentialOutcome = typeof ClaudeCredentialOutcome.Type;
export const ClaudeCredentialObservation = Schema.Struct({
  attemptId: Schema.String,
  credentialRef: Schema.String,
  identity: ClaudeAccountIdentity,
  observedAt: Schema.String,
  outcome: ClaudeCredentialOutcome,
  source: Schema.Literal("native-inference"),
});
export type ClaudeCredentialObservation = typeof ClaudeCredentialObservation.Type;

export const ClaudeConnectionFailure = Schema.Literals([
  "native-unavailable",
  "native-login-failed",
  "identity-unavailable",
  "identity-mismatch",
  "duplicate-account",
  "protected-storage-unavailable",
  "connection-failed",
  "verification-failed",
]);
export type ClaudeConnectionFailure = typeof ClaudeConnectionFailure.Type;

/** Public connection readback. No credential, authorization URL or native output. */
export const ClaudeConnectionState = Schema.Union([
  Schema.Struct({ state: Schema.Literal("idle") }),
  Schema.Struct({ state: Schema.Literal("authorizing"), connectionId: Schema.String }),
  Schema.Struct({ state: Schema.Literal("verifying"), connectionId: Schema.String }),
  Schema.Struct({ state: Schema.Literal("cancelled"), connectionId: Schema.String }),
  Schema.Struct({
    state: Schema.Literal("failed"),
    connectionId: Schema.String,
    reason: ClaudeConnectionFailure,
  }),
  Schema.Struct({
    state: Schema.Literal("connected"),
    connectionId: Schema.String,
    homePath: Schema.String,
    replacesConnectionId: Schema.optionalKey(Schema.String),
    operation: Schema.optionalKey(Schema.Literals(["verify", "reconnect"])),
    binaryPath: Schema.optionalKey(Schema.String),
    identity: ClaudeAccountIdentity,
    observedAt: Schema.String,
    verification: Schema.optionalKey(ClaudeCredentialObservation),
  }),
]);
export type ClaudeConnectionState = typeof ClaudeConnectionState.Type;
